import React, { useState } from "react";
import PropTypes from "prop-types";
import { WC } from "./word-cloud";
export function WordCloudGraph({
  data,
  identifier,
  onEntityClick,
  entityList,
  isEmbededWidget,
}) {
  const [tooltipContent, setTooltipContent] = useState(null);
  const [offset, setOffset] = useState({ x: 0, y: 0 });

  function onHoverOrClick(obj) {
    setTooltipContent(obj.text + " - " + obj.value);
  }

  function setTooltipPos(e) {
    if (!e || typeof e.target === "undefined") {
      return;
    }
    let xPos = e.layerX;
    let yPos = e.layerY;
    if (isEmbededWidget) {
      const embededFeedModal = document.getElementsByClassName("embededWidget");
      if (embededFeedModal) {
        xPos = xPos + 150;
      }
    }
    setOffset({
      x: xPos,
      y: yPos,
    });
  }
  return (
    <div
      onMouseLeave={() => setTooltipContent("")}
      id={identifier}
      style={{ cursor: "default" }}
    >
      <WC
        data={data}
        tooltipContent={tooltipContent}
        setTooltipContent={onHoverOrClick}
        setTooltipPos={setTooltipPos}
        onEntityClick={onEntityClick}
        entityList={entityList}
        identifier={identifier}
        isEmbededWidget={isEmbededWidget}
      />
      {tooltipContent && (
        <span
          style={{
            position: "absolute",
            top: offset.y,
            left: offset.x,
            color: "white",
            backgroundColor: "black",
            padding: "5px",
            borderRadius: "5px",
            fontStyle: "bold",
          }}
        >
          {tooltipContent}
        </span>
      )}
    </div>
  );
}

WordCloudGraph.defaultProps = {
  data: {},
};

WordCloudGraph.prototype = {
  data: PropTypes.shape({}),
};
